module.exports = __webpack_public_path__ + "img/logo_modern.4afaa82f.png";